import React, { useState, useEffect } from 'react';
import './styles.scss';
import { PropTypes } from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import CheckBox from '../../common/CheckBox';
import { noop } from '../propTypes';
import { DROPDOWN_VARIANTS } from '../constants';

const getDropDownItem = (item, variant, name, onCheckboxClick = noop) => {
    switch (variant) {
        case DROPDOWN_VARIANTS.CHECKBOX: {
            return (
                <CheckBox
                    key={`chbx_${item.id}`}
                    name={name}
                    onClick={() => {
                        onCheckboxClick(item);
                    }}
                    label={`${item.label}`}
                    selected={item.selected}
                    id={`chbx_${item.id}`}
                />
            );
        }
        case DROPDOWN_VARIANTS.LIST_ICON:
            return (
                <div>
                    <i className={item.icon} />
                    <span>{item.label}</span>
                </div>
            );
        default:
            return <span>{item.label}</span>;
    }
};

function DropDown({
    label,
    menuData,
    variant,
    onChange,
    multiple,
    checkboxName,
    permissions,
    selectedOption,
}) {
    const selectedOptions = [];
    // use State to update the dropdown label when the onSelect event is dispatched
    const [selected, setSelected] = useState(
        selectedOptions && selectedOptions.length > 1
            ? 'Multiple'
            : menuData[0] && menuData[0].label
            ? menuData[0].label
            : 'Select',
    );

    const [showDropdown, setShowDropdown] = useState(false);

    const [data, setData] = useState([]);

    useEffect(() => {
        const dropdownData = menuData.filter(
            (element) =>
                !element.isProtected ||
                permissions.indexOf(element.permission) > -1,
        );
        setData(dropdownData);
    }, [menuData]);

    useEffect(() => {
        if (multiple) {
            setSelected(
                selectedOptions && selectedOptions.length > 1
                    ? 'Multiple'
                    : selectedOptions && selectedOptions.length == 1
                    ? selectedOptions[0].tag
                    : 'Select',
            );
        } else {
            setSelected(
                selectedOption && selectedOption.length > 1
                    ? selectedOption
                    : selectedOptions && selectedOptions.length > 1
                    ? 'Multiple'
                    : data[0] && data[0].label
                    ? data[0].label
                    : 'Select',
            );
        }
    }, [data]);

    const multiOptionProps = {};

    if (multiple) multiOptionProps.show = showDropdown;

    return (
        <>
            {
                <Dropdown
                    onSelect={(evt) => {
                        const taxonomy = JSON.parse(evt);

                        let exist = false;
                        let existIndex = -1;

                        for (let i = 0; i < selectedOptions.length; i++) {
                            if (selectedOptions[i].tag === taxonomy.label) {
                                exist = true;
                                existIndex = i;
                            }
                        }

                        if (exist) selectedOptions.splice(existIndex, 1);
                        else selectedOptions.push({ tag: taxonomy.label });

                        onChange(multiple ? selectedOptions : taxonomy.key);
                        setSelected(taxonomy.label);
                    }}
                    onToggle={(isOpen, event, metadata) => {
                        if (multiple && metadata.source == 'click')
                            setShowDropdown(!showDropdown);
                    }}
                    className="custom-dropdown d-flex flex-row align-items-center"
                    {...multiOptionProps}
                >
                    <div className="label align-self-center d-flex flex-row">
                        <span>{label}</span>
                    </div>
                    <div className="dropDown">
                        <Dropdown.Toggle
                            className="btn dropdown-toggle dropdown-toggle-split"
                            variant={'none'}
                        >
                            {selected}
                        </Dropdown.Toggle>
                    </div>
                    {data.length ? (
                        <Dropdown.Menu className="dropdown-menu dropdown-menu-left">
                            {data.map((item) => {
                                if (
                                    item.selected ||
                                    item.key === selectedOption
                                )
                                    selectedOptions.push({ tag: item.label });

                                return (
                                    <Dropdown.Item
                                        key={`dpitem-${item.id}`}
                                        className={`dropdown-item ${
                                            selected === item.label
                                                ? 'active'
                                                : ''
                                        } ${variant}`}
                                        eventKey={JSON.stringify(item)} // react bootstrap currently unable to stringify object in onSelect value
                                    >
                                        {getDropDownItem(
                                            item,
                                            variant,
                                            checkboxName,
                                            (item) => {
                                                data.map((single) => {
                                                    if (item.id === single.id)
                                                        single.selected = true;

                                                    return single;
                                                });

                                                setData([...data]);
                                            },
                                        )}
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    ) : null}
                </Dropdown>
            }
        </>
    );
}

DropDown.propTypes = {
    // label that will appear on dropdown
    label: PropTypes.string,
    // drop down data that will appear in menu
    menuData: PropTypes.arrayOf(PropTypes.object),
    // type of drop down items
    variant: PropTypes.string,
    // event handler for when a dropdown option is selected
    onChange: PropTypes.func,

    multiple: PropTypes.bool,

    checkboxName: PropTypes.string,
    selectedOption: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
};

DropDown.defaultProps = {
    // label that will appear on dropdown
    label: 'Period',
    // drop down data that will appear in menu
    menuData: [],
    // type of drop down items
    variant: 'checkbox',
    selectedOption: '',
    // default function passed as event handler when none is provided
    onChange: noop,

    multiple: false,

    checkboxName: null,
    permissions: [],
};

export default DropDown;
